import { Component, computed, input } from '@angular/core';

import {
  formatCellValue,
  processNumberValue
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

@Component({
  selector: 'app-number-cell',
  standalone: true,
  templateUrl: './number-cell.component.html'
})
export class NumberCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => this.withUnit(formatCellValue(v, 'number'));

  value = input<unknown | undefined>(undefined);
  unit = input<string | undefined>(undefined);

  protected processedValue = computed<string>(() => processNumberValue(this.value()));

  private withUnit(formatted: string): string {
    const unit = this.unit();
    return formatted && unit ? `${formatted} ${unit}` : formatted;
  }
}
